// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostCallActions_wrapper__33Sx4","actions":"PostCallActions_actions__2Mumq"};